import { ErrorModel } from '@era/app';
import { IReckonInRoomCredentials } from '@era/locations-sdk';
import { createActionGroup, props } from '@ngrx/store';
import { Category } from '../router/category';
import { InRoomCredentialsConfiguration } from './category-in-room-credentials.state';

// ============================================================================
// RESOLVER ACTIONS (Group - using createActionGroup)
// ============================================================================

export const CategoryInRoomCredentialsResolverActions = createActionGroup({
  source: 'InRoom Credentials resolver',
  events: {
    'Category credentials requested': props<{ category: Category }>(),
  },
});

// ============================================================================
// API ACTIONS (Group - using createActionGroup)
// ============================================================================

export const CategoryInRoomCredentialsApiActions = createActionGroup({
  source: 'InRoom Credentials API',
  events: {
    'Category credentials loaded': props<{ configuration: InRoomCredentialsConfiguration }>(),
    'Category credentials loaded error': props<{ error: ErrorModel }>(),
    'Category credentials added': props<{ configuration: InRoomCredentialsConfiguration }>(),
    'Category credentials added error': props<{ configuration: InRoomCredentialsConfiguration; error: ErrorModel }>(),
    'Category credentials updated': props<{ configuration: InRoomCredentialsConfiguration }>(),
    'Category credentials updated error': props<{ configuration: InRoomCredentialsConfiguration; error: ErrorModel }>(),
    'Category credentials deleted': props<{ configuration: InRoomCredentialsConfiguration }>(),
    'Category credentials deleted error': props<{ configuration: InRoomCredentialsConfiguration; error: ErrorModel }>(),
  },
});

// ============================================================================
// VIEW ACTIONS (Group - using createActionGroup)
// ============================================================================

export const CategoryInRoomCredentialsViewActions = createActionGroup({
  source: 'InRoom Credentials view',
  events: {
    'Credentials selected': props<{ category: Category; credentials: IReckonInRoomCredentials }>(),
    'Credentials deselected': props<{ category: Category }>(),
  },
});
